export default __webpack_public_path__ + "static/media/arrow_down.1f2302aa.png";